import { SubscriptionStatusTranslationMap } from "@/enums/status";

/**
 * Normalizes API / DB status values for map lookup (whitespace, casing).
 */
export function normalizeSubscriptionStatusKey(raw) {
  if (raw === null || raw === undefined || raw === "") return "";
  return String(raw).trim().toLowerCase();
}

/**
 * Human-readable subscription status using i18n. Never passes the raw slug to $t()
 * (that would make vue-i18n echo "ended" when the key is missing).
 */
export function subscriptionStatusLabel($t, raw) {
  const key = normalizeSubscriptionStatusKey(raw);
  if (!key) return "";

  const legacyFallbackByStatus = {
    ended: "seller.contracts.text_2459",
    canceled: "seller.contracts.text_2458",
  };

  const i18nKey = SubscriptionStatusTranslationMap[key];
  if (!i18nKey) {
    const fallbackKey = legacyFallbackByStatus[key];
    return fallbackKey ? $t(fallbackKey) : String(raw).trim();
  }

  let label = $t(i18nKey);

  // If the primary key did not resolve (missing locale, bad merge), use contract labels where available.
  const unresolved =
    label === key ||
    label === i18nKey ||
    (typeof label === "string" && label.indexOf("shared.") === 0);

  if (unresolved) {
    const fallbackKey = legacyFallbackByStatus[key];
    if (fallbackKey) return $t(fallbackKey);
  }

  return label;
}
